import React from 'react';

import {AvailabilityStatus, AVAILABLE_TEXT, USED_TEXT} from 'runs/inbox/RunsInboxModalConstants';
import pickDefined from 'util/pickDefined';

import {FilterKey, SingleValueFilterWithDefault} from '../SearchConstants';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import SingleValueDropdownFilterForm from './base/SingleValueDropdownFilterForm';

export interface RunAvailabilityFilter extends SingleValueFilterWithDefault {
  key: FilterKey.RUN_AVAILABILITY;
  value: AvailabilityStatus;
}

interface Props extends BaseFilterFormProps {
  filter: RunAvailabilityFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: RunAvailabilityFilter) => void;
}

export default function RunAvailabilityFilterForm(props: Props): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <SingleValueDropdownFilterForm
      {...skeletonProps}
      value={props.filter.value}
      onChangeValue={(value: AvailabilityStatus) => {
        props.onChangeFilter({...props.filter, value});
      }}
      optionDatas={[
        {name: AVAILABLE_TEXT, value: AvailabilityStatus.AVAILABLE},
        {name: USED_TEXT, value: AvailabilityStatus.IN_ENTRY},
      ]}
      filterStyle={props.filterStyle}
    />
  );
}
